import * as Sentry from '@sentry/vue';
import { App } from 'vue';
import { Router } from 'vue-router';

function initSentry(app: App, router: Router) {
   if (!['prod'].includes(import.meta.env.VITE_APP_ENV)) return;

   const env = import.meta.env.VITE_APP_ENV;
   const dsn = import.meta.env.VITE_APP_SENTRY_DNS;

   const packageJson = import.meta.glob('/package.json', { eager: true });
   const version = (packageJson['/package.json'] as { version: string })?.version || 'KOAS';

   Sentry.init({
      app,
      dsn,
      environment: env,

      attachProps: true,
      integrations: [
         Sentry.browserTracingIntegration({ router }),
         Sentry.feedbackIntegration({
            colorScheme: 'system',
         }),
         Sentry.breadcrumbsIntegration({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true,
         }),
         Sentry.browserProfilingIntegration(),
      ],
      tracesSampleRate: 1.0,
      attachStacktrace: true,
      release: version,
      replaysSessionSampleRate: 0.5,
      replaysOnErrorSampleRate: 0.5,
   });

   Sentry.setContext('env', { origin: import.meta.env.VITE_APP_BASE_URL, mode: import.meta.env.VITE_APP_ENV });
}

export { initSentry };
